import { useTranslation } from "@/i18n/client";
import { ContextModalProps } from "@mantine/modals";
import { Box } from "@mantine/core";
import { Modal } from "@/components/Modal";
import Link from "@/components/Link";
import { Trans } from "react-i18next";
import Text from "@/components/Text";
import ButtonsGroup from "@/components/ButtonsGroup";
import { useRouter } from "next/navigation";

export const contractCanNotBeModifiedContext = {
  modal: "contractCanNotBeModified",
  closeOnClickOutside: false,
  closeOnEscape: false,
  withCloseButton: false,
  innerProps: {},
};

export const ContractCanNotBeModified = ({ context, id, innerProps }: ContextModalProps) => {
  const { t } = useTranslation("modals");
  const router = useRouter();

  const redirect = () => {
    context.closeModal(id);
    router.push("https://www.eon.cz/");
  };

  return (
    <Box pos="relative">
      <Modal.Title>{t("contractCanNotBeModified.title")}</Modal.Title>
      <Modal.Description
        description={
          <Text variant="reading_medium">
            <Trans
              t={t}
              i18nKey="contractCanNotBeModified.description"
              components={{
                eonLink: <Link href="https://www.eon.cz/domacnosti/zakaznicka-pece/prepis/" key="prepisLink" />,
              }}
            />
          </Text>
        }
      />
      <ButtonsGroup rightButtonText={t("contractCanNotBeModified.cancel")} onRightButtonClick={redirect} withLeftButton={false} />
    </Box>
  );
};
